import { jsx as _jsx } from "react/jsx-runtime";
import { t } from '@mp/locale';
function format(datetime) {
    // Pass in data from order context and selected slot. See example from cloud
    t("CAPTURE_SERVICES.SCHEDULER.formattedDateTime");
    // $scope.schedule.formatted = $translate.instant('CAPTURE_SERVICES.SCHEDULER.formattedDateTime', {
    //   date: selectedDatetime.toLocaleDateString(currentLang, {weekday: 'short', month: 'short', day: 'numeric'}),
    //   time: selectedDatetime.toLocaleTimeString(currentLang, {hour: 'numeric', minute: 'numeric', 'timeZone': $scope.timeZone }),
    //   timezone: $scope.timeZoneAbbrev
    // });
}
export default function SchedulerValid(_a) {
    var order = _a.order, selectedSlot = _a.selectedSlot;
    // Use order context to pass in values to translated string
    if (!selectedSlot.datetime) {
        return null;
    }
    return (_jsx("div", { className: "mp-scheduler-valid-message", dangerouslySetInnerHTML: {
            __html: t("CAPTURE_SERVICES.SCHEDULER.validMessage", null, {
                formattedDate: selectedSlot.formattedDateTime,
            }),
        } }));
}
